/**
 * One player row (unit convention §1).
 *
 * `side` is white/black, NOT "me"/"opponent": which of the two rows is on top
 * follows the board orientation, so flipping the board swaps the two elements
 * and each row simply re-reads its own seat.
 */
import React from 'react';

import type {Side} from '@/Store/liveGame/state';

import {bump} from '../renderCount';
import {usePlayerRowModel} from './model';
import PlayerRowView from './View';

export default React.memo(function PlayerRow({side}: {side: Side}) {
  bump('PlayerRow');
  return <PlayerRowView side={side} {...usePlayerRowModel(side)} />;
});
